// Swag storefront helpers — shared by the grid (/swag) and the product page (/swag/:slug).
// The store shows ONE CARD PER COLOR: an item with a colors[] list explodes into one card per color
// (e.g. "OpticSwap Tee — Olive" / "— Black"), each with its own readable slug + product page.

export const swagSlugify = (s) =>
  String(s || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

// Turn the API items into flat "cards". A colored item → one card per color; a plain item → one card.
export function explodeSwagItems(items) {
  const cards = [];
  for (const it of items || []) {
    const base = it.slug || swagSlugify(it.name);
    const colors = it.colors || [];
    if (colors.length > 0) {
      colors.forEach((c) =>
        cards.push({
          key: `${it.item_id}__${c.name}`,
          item: it,
          colorName: c.name,
          title: `${it.name} — ${c.name}`,
          image: c.image_url || it.image_url || "",
          slug: `${base}-${swagSlugify(c.name)}`,
        })
      );
    } else {
      cards.push({
        key: it.item_id,
        item: it,
        colorName: "",
        title: it.name,
        image: it.image_url || "",
        slug: base,
      });
    }
  }
  return cards;
}
